export default "__VITE_ASSET__jpEW48SK__"